// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"241c2461","122":"364ce582","256":"93e1b058","398":"e126a29b","420":"6f1ed9a5","662":"2fecb08e","700":"8887e5a8","844":"0acfc83c","902":"f94362e5"}[chunkId] + ".chunk.js";
};